module.exports = __webpack_public_path__ + "static/OldMansJourney3-3f377da88968091086a09a14610906ec.webp";